<template>
    <div class="userManage" v-loading="fullscreenLoading">

        <div class="breadcrumb">所有用户</div>

        <div class="tips-content">
            <p>提示：</p>
            <p>1，用户id最多输入10位</p>
        </div>

        <div class="search-bezel">
            <el-select v-model="status">
                <el-option label="用户ID" value='0'></el-option>
                <el-option label="姓名" value='1'></el-option>
                <el-option label="手机号" value='2'></el-option>
                <el-option label="学号" value='3'></el-option>
            </el-select>

            <div class="el-input">
                <input class="el-input__inner" type="text" :placeholder="placeholder" v-model="keyWord"
                    @keyup.enter="search"></input>
            </div>

            <el-button type="primary" @click="search">搜索</el-button>
            <el-upload style="display: inline-block;" :with-credentials='true' name="uploadFile" :show-file-list="false"
                :action="`${$util.domain}/adminapi/v1/user/batchUpdateUsers`" :headers="headers" :on-success="success"
                :on-error="fail" :before-upload="beforeUpload">
                <el-button type="primary">
                    批量修改
                </el-button>
            </el-upload>
            <el-button type="primary">
                <a style="color: #fff;"
                    href="https://admin.gxapp.iydsj.com/template/%E7%94%A8%E6%88%B7%E6%A8%A1%E6%9D%BF.xls">
                    学校模板下载
                </a>
            </el-button>

            <el-button class="right_f" type="primary" @click="clickFreezeConfig">冻结配置</el-button>
        </div>

        <div class="com-list">
            <el-table :data="users" style="overflow-x: auto;">
                <el-table-column align="center" label="序号" prop="index" width="80"></el-table-column>
                <el-table-column align="center" label="用户ID" prop="id"></el-table-column>
                <el-table-column align="center" label="手机号" prop="phone"></el-table-column>
                <el-table-column align="center" label="姓名" prop="name"></el-table-column>
                <el-table-column align="center" label="校区" prop="university"></el-table-column>
                <el-table-column align="center" label="学号/教职工号" prop="campusId"></el-table-column>
                <el-table-column align="center" label="院系" prop="className"></el-table-column>
                <el-table-column align="center" label="入学年份" prop="caid"></el-table-column>
                <el-table-column align="center" label="状态" width="100">
                    <template scope="{ row }">
                        <span :style="{ color: row.enabled === 1 ? '#67C23A' : '#909399' }">
                            {{ row.enabled === 1 ? '在线' : '注销' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="440">
                    <template scope="{ row }">
                        <!-- <el-button class="option" type="text" v-if="row.isOff === 0" @click="maekOff(row, 1)">封号</el-button>
                        <el-button class="option" type="text" v-if="row.isOff === 1" @click="maekOff(row, 0)">取消封号</el-button> -->
                        <el-button class="option" type="text" v-if="row.isBanned === 0"
                            @click="bannedUser(row, 1)">禁言</el-button>
                        <el-button class="option" type="text" v-if="row.isBanned === 1"
                            @click="bannedUser(row, 0)">取消禁言</el-button>
                        <el-button class="option" type="text" @click="changecampus($index, row)">切换校区</el-button>
                        <el-button class="option" type="text" @click="changephone($index, row)">更改手机号</el-button>
                        <el-button class="option" type="text" @click="changedepartment($index, row)">更改院系</el-button>
                        <el-button class="option" type="text" @click="changeyear($index, row)">更改入学年份</el-button>
                        <el-button class="option" type="text" v-if="row.duration > 0"
                            @click="clickUnfreeze($index, row)">解冻</el-button>
                        <el-button class="option" type="text" @click="logout($index, row)">注销</el-button>
                        <el-button type="text" @click="clickDonate(row)">赠送</el-button>
                        <el-button class="option" type="text" @click="clickViewCertify(row)">查看实名认证</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination">
            <el-pagination v-show="this.totalCount > 0" layout="prev, pager, next, jumper" :page-size="20"
                :current-page="currentPage" :total="totalCount" @current-change="handleCurrentChange">
            </el-pagination>
        </div>

        <el-dialog title="更换校区" v-model="changecampusvisible" :modal-append-to-body="false">
            <div style="line-height: 38px;">
                <p>用户ID:{{ form.id }}</p>
                <p>用户姓名:{{ form.name }} 　　　　学号：{{ form.stuId }}</p>
                <p>学校校区:{{ form.campus }}</p>
                <p>手机号:{{ form.phone }}</p>
                <p>院系:{{ form.className }}</p>
                <p>入学年份:{{ form.caid }}</p>
                <p style="font-size: 14px; color: red;">提示：切换校区后，学生当前成绩将不会计入新校区</p>
            </div>

            <el-form :model="formcampus">
                <span style="font-weight: bold; color: #333;">切换到 学校校区:　</span>
                <el-select v-model="value8" filterable clearable placeholder="请选择">
                    <el-option v-for="item in options" :label="item.name" :value="item.unid" :key="item.name">
                    </el-option>
                </el-select>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="changecampusubmit">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改手机号" v-model="changephonevisible" :modal-append-to-body="false">
            <p>用户ID:{{ form.id }}</p>
            <p>用户姓名:{{ form.name }} 　　　　学号：{{ form.stuId }}</p>
            <p>学校校区:{{ form.campus }}</p>
            <p>手机号:{{ form.phone }}</p>
            <p> 院系:{{ form.className }}</p>
            <p>入学年份:{{ form.caid }}</p>
            <el-form :model="form">
                <el-form-item label="手机号修改为" :label-width="formLabelWidth">
                    <el-input v-model="form.newphone" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="changephonesubmit">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="更改院系" v-model="changedepartmentvisible" :modal-append-to-body="false">
            <p>用户ID:{{ form.id }}</p>
            <p>用户姓名:{{ form.name }} 　　　　学号：{{ form.stuId }}</p>
            <p>学校校区:{{ form.campus }}</p>
            <p>手机号:{{ form.phone }}</p>
            <p> 院系:{{ form.className }}</p>
            <p>入学年份:{{ form.caid }}</p>
            <el-select v-model="valuedepartment" filterable clearable placeholder="请选择">
                <el-option v-for="item in optionsdepartment" :label="item.department"
                    :value="item.id + ',' + item.department" :key="item.id">
                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="changedepartmentsubmit">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="更改入学年份" v-model="changeyearvisible" :modal-append-to-body="false">
            <p>用户ID:{{ form.id }}</p>
            <p>用户姓名:{{ form.name }} 　　　　学号：{{ form.stuId }}</p>
            <p>学校校区:{{ form.campus }}</p>
            <p>手机号:{{ form.phone }}</p>
            <p>院系:{{ form.className }}</p>
            <p>入学年份:{{ form.caid }}</p>
            <el-select v-model="selectedyear" filterable clearable placeholder="请选择">
                <el-option v-for="item in allyear" :key="item.value" :label="item.value" :value="item.value">
                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="changeyearsubmit">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="冻结配置" size="tiny" :modal-append-to-body="false" v-model="freezeDialog.visible">
            <el-form class="freeze-form">
                <el-form-item label="开启选择">
                    <el-radio-group v-model="freezeForm.type">
                        <el-radio :label="2">部分开启</el-radio>
                        <el-radio :label="1">全部</el-radio>
                    </el-radio-group>
                </el-form-item>
                <p>部分开启的情况下，只会针对下方学校的学生进行冻结处理</p>
                <el-form-item :label="freezeForm.type == 2 ? '开启学校' : '白名单学校'">
                    <div class="select-bezel">
                        <el-select placeholder="请选择校区" filterable v-model="freezeForm.campusUnid">
                            <el-option v-for="(item, index) in freezeDialog.campusList" :key="index" :label="item.name"
                                :value="item.unid"></el-option>
                        </el-select>
                        <el-button type="primary" @click="clickFreezeAddCampus">添加</el-button>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="card-wrap">
                        <div v-for="(item, index) in freezeForm.campusZones" :key="index" class="card-item">
                            <span>{{ item.name }}</span>
                            <el-button type="text" icon="circle-close"
                                @click="clickFreezeDeleteCampus(item.unid)"></el-button>
                        </div>
                    </div>
                    <div class="card-footer">共计{{ freezeForm.campusZones.length }}所学校</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="freezeDialog.visible = false">取 消</el-button>
                <el-button type="primary" @click="clickFreezeConfigDone">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="赠送" size="tiny" :modal-append-to-body="false" :destroy-on-close="true"
            v-model="donationDialog.visible">
            <el-form ref="donationFormRef" label-width="100px" label-position="left" :model="donationParam"
                :rules="donationDialog.rules">
                <el-form-item label="选择类型" prop="type">
                    <el-select v-model="donationParam.type">
                        <el-option label="体验卡" :value="1"></el-option>
                        <el-option label="会员" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择体验卡" v-show="donationParam.type == 1" prop="experienceCardId">
                    <el-select v-model="donationParam.experienceCardId">
                        <el-option v-for="(item, index) in donationDialog.experienceCardOptions" :key="index"
                            :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <div>剩余数量：{{ experienceResidualQuantity }}张</div>
                </el-form-item>
                <el-form-item label="选择会员" v-show="donationParam.type == 2" prop="memberCardId">
                    <el-select v-model="donationParam.memberCardId">
                        <el-option v-for="(item, index) in donationDialog.memberCardOptions" :key="index"
                            :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="体验卡数量" v-show="donationParam.type == 1" prop="count">
                    <el-input-number :controls="false" :min="0" :step="1"
                        v-model="donationParam.count"></el-input-number>
                    <span>张</span>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="flex-row-center gap-10">
                    <el-button @click="donationDialog.visible = false">取消</el-button>
                    <el-button type="primary" @click="clickDonationDone">确认</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 查看支付宝实名认证：1.4 的 el-dialog 没有 value prop，必须用 :visible.sync -->
        <el-dialog title="查看支付宝实名认证" size="middle" v-model="certifyDialog.visible" :modal-append-to-body="false" class="certify-dialog">
            <div class="certify-status-bar">
                <span class="certify-status-bar__text">
                    当前状态：{{ certifyDialog.certified ? '已实名认证' : '未实名认证' }}
                </span>
                <el-button v-if="certifyDialog.certified" plain type="danger" size="small" @click="clickUnbindCertify">
                    解绑实名认证
                </el-button>
            </div>

            <!-- 认证记录 / 解绑记录 切换：type 1-认证记录，2-解绑记录 -->
            <el-tabs v-model="certifyDialog.type" class="certify-tabs" @tab-click="handleCertifyTabClick">
                <el-tab-pane label="认证记录" name="1"></el-tab-pane>
                <el-tab-pane label="解绑记录" name="2"></el-tab-pane>
            </el-tabs>

            <el-table v-loading="certifyDialog.loading" :data="certifyDialog.records" border style="width: 100%;">
                <el-table-column align="center" label="状态">
                    <template scope="{ row }">{{ getCertifyStatusText(row) }}</template>
                </el-table-column>
                <el-table-column align="center" label="姓名" prop="certName">
                    <!-- <template scope="{ row }">{{ formatCertifyTime(row.createTime) }}</template> -->
                </el-table-column>
                <el-table-column align="center" label="证件类型" prop="certType">
                    <template scope="{ row }">{{ formatCertType(row.certType) }}</template>
                </el-table-column>
                <el-table-column align="center" label="证件号" prop="certNo" min-width="150">
                    <!-- <template scope="{ row }">{{ formatCertifyTime(row.createTime) }}</template> -->
                </el-table-column>
                <el-table-column align="center" label="操作时间" min-width="150">
                    <template scope="{ row }">{{ formatCertifyTime(row.createTime) }}</template>
                </el-table-column>
                <el-table-column align="center" label="操作人">
                    <template scope="{ row }">{{ row.operatorName }}</template>
                </el-table-column>
            </el-table>

            <div class="certify-pagination">
                <el-pagination v-show="certifyDialog.total > 0" layout="total, prev, pager, next"
                    :current-page="certifyDialog.pageNumber" :page-size="certifyDialog.pageSize"
                    :total="certifyDialog.total" @current-change="handleCertifyPageChange">
                </el-pagination>
            </div>
        </el-dialog>

        <!-- 解绑二次确认：单独 dialog，不用 this.$confirm -->
        <el-dialog title="提示" v-model="unbindConfirm.visible" :modal-append-to-body="false"
            width="420px" :close-on-click-modal="false">
            <div class="unbind-confirm-body">
                <i class="el-icon-warning unbind-confirm-body__icon"></i>
                <span>确定要解绑该用户的实名认证吗？解绑后将立即生效。</span>
            </div>
            <template #footer>
                <div class="flex-row-center gap-10">
                    <el-button type="danger" plain @click="unbindConfirm.visible = false" :disabled="unbindConfirm.loading">取消</el-button>
                    <el-button type="danger" :loading="unbindConfirm.loading" @click="confirmUnbindCertify">确定</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        const validateExperienceCard = (rule, value, callback) => {
            if (this.donationParam.type == 1 && this.donationParam.experienceCardId === '') {
                return callback(new Error('请选择体验卡'));
            }
            callback();
        };
        const validateMemberCard = (rule, value, callback) => {
            if (this.donationParam.type == 2 && this.donationParam.memberCardId === '') {
                return callback(new Error('请选择会员'));
            }
            callback();
        };
        return {
            fullscreenLoading: false,
            status: '0',
            keyWord: '',
            list: [],
            users: [],
            totalCount: 0,
            currentPage: 1,
            changephonevisible: false,
            form: {
                id: '',
                name: '',
                xuehao: '',
                campus: '',
                phone: '',
                newphone: '',
                stuId: '',
                className: '',
                caid: ''
            },
            formcampus: {
                id: '',
                name: '',
                xuehao: '',
                campus: '',
                phone: '',
                newphone: '',
                stuId: ''
            },
            options: [],
            optionsdepartment: [],
            changecampusvisible: false,
            rowstate: '',
            changedepartmentvisible: false,
            changeyearvisible: false,
            valuedepartment: null,
            value5: '',
            coidimport: '',
            classNameimport: '',
            allyear: [],
            selectedyear: '',
            value8: null,
            headers: {},
            freezeDialog: {
                visible: false,
                campusList: [],
            },
            freezeForm: {
                type: 2,
                campusUnid: null,
                campusZones: []
            },
            donationDialog: {
                visible: false,
                uid: '',
                experienceCardOptions: [],
                memberCardOptions: [],
                rules: {
                    type: [{ type: 'number', required: true, message: '请选择类型', trigger: 'blur' }],
                    experienceCardId: [{ required: true, validator: validateExperienceCard }],
                    memberCardId: [{ required: true, validator: validateMemberCard }],
                    count: [{ type: 'number', required: true, message: '请输入数量', trigger: 'blur' }],
                }
            },
            // 查看支付宝实名认证弹窗
            certifyDialog: {
                visible: false,
                loading: false,
                uid: '',
                certified: false,
                records: [],
                // 记录总数（服务端返回 totalCount，分页由后端完成）
                total: 0,
                pageNumber: 1,
                pageSize: 10,
                // 记录类型：'1'-认证记录，'2'-解绑记录（el-tabs 的 name 为字符串）
                type: '1',
            },
            // 解绑二次确认弹窗：单独 dialog，不用 $confirm
            unbindConfirm: {
                visible: false,
                loading: false,
            },
            donationParam: {
                type: 1,
                experienceCardId: '',
                memberCardId: '',
                count: 0
            }
        }
    },

    computed: {
        ...mapState(['user']),
        placeholder() {
            if (this.status === '0') {
                return '请输入用户ID'
            } else if (this.status === '1') {
                return '请输入姓名'
            } else if (this.status === '2') {
                return '请输入手机号'
            } else {
                return '请输入学号'
            }
        },
        // 体验卡剩余数量
        experienceResidualQuantity() {
            const experienceCard = this.donationDialog.experienceCardOptions.filter((item) => {
                return item.value == this.donationParam.experienceCardId
            })
            if (experienceCard.length) {
                const card = experienceCard[0];
                if (card.quantity == -1) {
                    return '∞';
                } else {
                    return experienceCard[0].residualQuantity;
                }
            } else {
                return '';
            }
        }
    },

    mounted() {
        this.headers.userId = this.user.userId;
        this.inneryear();
        this.queryExperienceCardList();
        this.queryMemberCardList();
    },

    methods: {
        // 初始化年份
        inneryear() {
            let myDate = new Date();
            let startYear = myDate.getFullYear() - 50;//起始年份
            let endYear = myDate.getFullYear() + 50;//结束年份

            for (let i = startYear; i <= endYear; i++) {
                this.allyear.push(new Option(i, i))
            }
        },

        // 点击搜索
        search() {
            //点击搜索之前把暂无数据隐藏,然后根据数据是否为空判断要不要显示
            //前端做一些判断限制
            //用户id,后台需要int值
            if (!this.keyWord) {
                this.$util.errorMsg('请输入关键词', '错误');
                return false;
            }
            let regstuId = /^[0-9]*$/;
            if (this.status == 0) {
                if (!regstuId.test(this.keyWord)) {
                    this.$util.errorMsg('输入的学生id不符合规则', '错误');
                    return false;
                }
                if (this.keyWord.length > 10) {
                    this.$util.errorMsg('学生id不能超过10位数字', '错误');
                    return false;
                }
                else {
                    this.keyWord = (this.keyWord) * 1;
                }
            }
            let regphone = /^1[3456789]\d{9}$/;
            if (this.status == 2) {
                if (!regphone.test(this.keyWord)) {
                    this.$util.errorMsg('输入的手机号不符合规则', '错误');
                    return false;
                }
            }
            //获取动态
            this.getList();
        },

        // 获取列表
        getList() {
            this.$http({
                method: 'POST',
                url: this.$util.domain + '/adminapi/v590/user/basicUser/list',
                body: JSON.stringify({
                    keyType: this.status * 1,
                    keyword: this.keyWord,
                    pageNum: this.currentPage,
                    pageSize: 20
                })
            }).then((response) => {
                if (response.data.error === 10000) {
                    let data = response.data.data;
                    if (data.totalCount > 0) {
                        this.list = data.dataList;
                        this.totalCount = data.totalCount;
                        this.analysisUserList();
                    } else if (data.totalCount === 0) {
                        this.list = [];
                        this.users = [];
                        this.totalCount = data.totalCount;
                    }
                } else {
                    this.$util.errorMsg(response.data.message, '错误');
                }
            }, (response) => {
                this.$util.errorMsg(response.data.message, '错误');
            })
        },

        // 解析用户列表
        analysisUserList() {
            this.users = [];
            if (this.list.length) {
                for (let i = 0; i < this.list.length; i++) {
                    let $index = (this.currentPage - 1) * 20 + i + 1,
                        $id = this.list[i].uid,
                        $phone = this.list[i].phone,
                        $name = this.list[i].name,
                        $university = this.list[i].university,
                        $campus = this.list[i].campus,
                        $campusId = this.list[i].campusId,
                        $isBanned = this.list[i].isBanned,
                        $stuId = this.list[i].stuId,
                        $coid = this.list[i].coid,//院系id
                        $className = this.list[i].className,//院系名称
                        $caid = this.list[i].caid,//入学年份
                        $unid = this.list[i].unid,//校区id
                        $duration = this.list[i].duration, // 冻结时长，0表示未冻结
                        $enabled = this.list[i].enabled // 账号状态，1表示在线，0表示注销

                    this.users.push({
                        index: $index,
                        id: $id,
                        phone: $phone,
                        name: $name,
                        campusId: $campusId,
                        university: $university,
                        isBanned: $isBanned,
                        stuId: $stuId,
                        coid: $coid,
                        className: $className,
                        caid: $caid,
                        unid: $unid,
                        duration: $duration,
                        enabled: $enabled,
                    });
                }
            }
        },

        // 获取所有校区
        queryAllCampusZones() {
            this.$http({
                url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
                method: "GET",
            }).then((res) => {
                if (res.body.data && res.body.data.length) {
                    this.freezeDialog.campusList = res.body.data.map((item) => ({
                        name: item.name,
                        unid: item.unid,
                    }));
                } else {
                    this.freezeDialog.campusList = [];
                }
            }).catch((error) => {
                this.freezeDialog.campusList = [];
            });
        },

        // 获取体验卡列表
        queryExperienceCardList() {
            this.$http({
                url: this.$util.domain + '/adminapi/experienceCard/all',
                method: 'GET',
            }).then((res) => {
                const list = res.data.data || [];
                this.donationDialog.experienceCardOptions = list.map((item) => ({
                    label: item.name,
                    value: item.id,
                    quantity: item.quantity,
                    residualQuantity: item.residualQuantity
                }));
            }).catch((err) => {
                this.donationDialog.experienceCardOptions = [];
            })
        },

        // 获取会员列表
        queryMemberCardList() {
            const params = {
                status: 1, // 状态（-1全部 1已发布 2撤销发布）
                pageNum: 1,
                pageSize: 10000,
            }
            this.$http({
                url: this.$util.domain + '/adminapi/privilegeConfig/list',
                method: 'GET',
                params: params
            }).then((res) => {
                const list = res.data.data.models || [];
                this.donationDialog.memberCardOptions = list.map((item) => ({
                    label: item.name,
                    value: item.id,
                }));
            }).catch((err) => {
                this.donationDialog.memberCardOptions = [];
            })
        },

        // 查询冻结配置
        queryFreezeConfig() {
            this.$http({
                url: this.$util.domain + '/run/runFreeze/getConfig',
                method: 'GET'
            }).then((res) => {
                if (res.data.error === 10000) {
                    this.freezeForm.type = res.data.data.applicable || 2;
                    this.freezeForm.campusZones = res.data.data.runFreezeCampusModels || [];
                    this.freezeDialog.visible = true;
                } else {
                    this.$util.errorMsg('获取冻结配置错误');
                }
            }).catch((err) => {
                this.$util.errorMsg('获取冻结配置错误');
            });
        },

        // 发送冻结配置
        sendFreezeConfig() {
            let params = { applicable: this.freezeForm.type };
            params['runFreezeCampusModels'] = this.freezeForm.campusZones.map((item) => {
                return Object.assign({}, item, { value: this.freezeForm.type });
            })
            this.$http({
                url: this.$util.domain + '/run/runFreeze/update',
                method: 'POST',
                body: JSON.stringify(params)
            }).then((res) => {
                if (res.data.error === 10000) {
                    this.freezeDialog.visible = false;
                    this.$util.successMsg('配置成功');
                } else {
                    this.$util.errorMsg(res.data.message);
                }
            }).catch((err) => {
                this.$util.errorMsg('配置失败');
            });
        },

        // 发送解冻信息
        sendUnfreeze(row) {
            this.$http({
                url: this.$util.domain + '/adminapi/v590/user/unfreeze',
                method: 'POST',
                body: JSON.stringify({ unid: row.unid, uid: row.id })
            }).then((res) => {
                if (res.data.error === 10000) {
                    this.$util.successMsg('解冻成功');
                    this.getList();
                } else {
                    this.$util.errorMsg(res.data.message);
                }
            }).catch((err) => {
                this.$util.errorMsg('解冻失败');
            });
        },

        // 发送赠送
        sendDonation() {
            this.loading = true;
            let url = '';
            let params = {
                uid: this.donationDialog.uid,
            }
            if (this.donationParam.type == 1) {
                url = this.$util.domain + '/adminapi/experienceCard/give';
                params['cardId'] = this.donationParam.experienceCardId;
                params['num'] = this.donationParam.count;
            } else if (this.donationParam.type == 2) {
                url = this.$util.domain + '/adminapi/privilege/v1/send';
                params['privilegeConfigId'] = this.donationParam.memberCardId * 1;
            }
            this.$http({
                url: url,
                method: 'POST',
                dataType: 'json',
                body: params
            }).then((res) => {
                if (res.body.error === 10000) {
                    this.donationDialog.visible = false;
                    this.$util.successMsg(res.body.message);
                } else {
                    this.$util.errorMsg(res.body.message);
                }
            }).catch((err) => {
                this.$message.error(err.message || "请联系管理员");
            }).finally(() => {
                this.loading = false;
            })
        },

        // 导入之前
        beforeUpload() {
            this.fullscreenLoading = true;
        },

        // 导入成功
        success(response) {
            setTimeout(() => {
                this.fullscreenLoading = false;
                if (response.error !== 10000) {
                    this.$util.errorMsg(response.message);
                } else {
                    this.$util.successMsg("上传成功");
                    this.search();
                }
            }, 2000);
        },

        // 导入失败
        fail() {
            this.fullscreenLoading = false;
            this.$util.errorMsg("上传失败");
        },

        // 点击冻结配置
        clickFreezeConfig() {
            if (this.freezeDialog.campusList.length == 0) {
                this.queryAllCampusZones();
            }
            this.queryFreezeConfig();
        },

        // 点击添加冻结校区
        clickFreezeAddCampus() {
            const selectCampus = this.freezeForm.campusZones.find((item) => {
                return item.unid === this.freezeForm.campusUnid;
            });
            if (selectCampus && JSON.stringify(selectCampus) !== "{}") {
                this.freezeForm.campusUnid = null;
                return;
            }
            const data = this.freezeDialog.campusList.find((item) => {
                return item.unid === this.freezeForm.campusUnid;
            });
            if (data && JSON.stringify(data) !== "{}") {
                this.freezeForm.campusZones = [...this.freezeForm.campusZones, data];
                this.freezeForm.campusUnid = null;
            }
        },

        // 点击删除冻结校区
        clickFreezeDeleteCampus(unid) {
            const index = this.freezeForm.campusZones.findIndex((item) => item.unid === unid);
            this.freezeForm.campusZones.splice(index, 1);
        },

        // 点击冻结配置确定
        clickFreezeConfigDone() {
            this.sendFreezeConfig();
        },

        // 封号或取消封号
        maekOff(row, status) {
            let userId = row.id;
            let url = this.$util.domain + '/adminapi/v2/user/basicUser/isBanned?uid=' + userId + '&isBanned=' + status;

            this.$http({
                url,
                method: 'POST',
                body: JSON.stringify({
                    uid: userId,
                    isBanned: status
                })
            }).then(response => {
                if (response.data.error === 10000) {
                    this.search();
                } else {
                    this.$util.errorMsg(response.data.message, '错误');
                }
            })
        },

        // 点击禁言或取消禁言
        bannedUser(row, status) {
            let userId = row.id;
            this.$http({
                method: 'POST',
                url: this.$util.domain + '/adminapi/v2/user/basicUser/isBanned?uid=' + userId + '&isBanned=' + status,
                body: JSON.stringify({
                    uid: userId,
                    isBanned: status
                })
            }).then(response => {
                if (response.data.error === 10000) {
                    this.search();
                } else {
                    this.$util.errorMsg(response.data.message, '错误');
                }
            })
        },

        // 切换校区
        changecampus($index, row) {
            this.changecampusvisible = true;// 弹出框
            this.bindclickout(row);
            // 切换校区弹框弹出后,请求校区接口
            this.$http({
                method: 'get',
                url: this.$util.domain + '/adminapi/v1/basicTools/allCampusZones'
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.options = response.body.data;// 给option数组赋值，这里要在下拉列表里面展示出来
                    this.rowstate = row;
                } else {
                    this.$util.errorMsg(response.data.message);
                }
            })
        },

        // 更改校区提交
        changecampusubmit() {
            const path = '/adminapi/v1/user/basicUser/changeCampusZone?phone='
            this.$http({
                method: 'post',
                url: this.$util.domain + path + this.form.phone + '&newCampusZoneId=' + this.value8,
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.changecampusvisible = false;//关闭
                    this.search();
                } else {
                    this.$util.errorMsg(response.data.message);
                }
            })
        },

        // 更改手机号
        changephone($index, row) {
            this.changephonevisible = true;
            this.bindclickout(row);
        },

        // 更改手机号提交
        changephonesubmit() {
            let regphone = /^1[3456789]\d{9}$/;
            if (!regphone.test(this.form.newphone)) {
                this.$util.errorMsg('手机号码不符合格式');
                return false;
            }
            const path = '/adminapi/v1/user/basicUser/changePhone?oldPhone='
            this.$http({
                method: 'post',
                url: this.$util.domain + path + this.form.phone + '&newPhone=' + this.form.newphone,
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.rowstate.phone = this.form.newphone;
                    this.changephonevisible = false;
                    this.search();
                } else {
                    this.$util.errorMsg(response.data.message);
                }
            })

        },

        // 更改院系弹框
        changedepartment($index, row) {
            this.changedepartmentvisible = true;
            this.bindclickout(row);
            this.$http({
                method: 'post',
                url: this.$util.domain + '/adminapi/v1/campus/department/allDepartment?unid=' + row.unid,
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.optionsdepartment = response.data.data;
                } else {
                    this.$util.errorMsg(response.data.message);
                }
            })

        },

        // 更改院系提交
        changedepartmentsubmit() {
            //uid用户id，coid院系id，className院系名称
            if (this.valuedepartment == false) {
                this.$util.errorMsg("请选择校区");
                return false;
            } else {
                this.coidimport = this.valuedepartment.split(',')[0];
                this.classNameimport = this.valuedepartment.split(',')[1];
            }

            this.$http({
                method: 'post',
                url: this.$util.domain + '/adminapi/v1/user/basicUser/changeDepartment?uid=' + this.rowstate.id + '&coid=' + this.coidimport + '&className=' + this.classNameimport
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.$util.successMsg('修改成功');
                    this.changedepartmentvisible = false;
                    this.rowstate.className = this.classNameimport;//实时刷新
                } else {
                    this.$util.errorMsg(response.data.message);
                }
            })
        },

        // 更改年份弹框
        changeyear($index, row) {
            this.changeyearvisible = true;
            this.bindclickout(row);
        },

        // 更改入学年份提交
        changeyearsubmit() {
            //uid用户id, caid入学年份id
            if (this.selectedyear == '') {
                this.$util.errorMsg('请选择年份');
                return false;
            }
            this.$http({
                url: this.$util.domain + '/adminapi/v1/user/basicUser/changeCaid?uid=' + this.rowstate.id + '&caid=' + this.selectedyear,
                method: 'post'
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.$util.successMsg('修改成功');
                    this.changeyearvisible = false;
                    this.rowstate.caid = this.selectedyear;
                } else {
                    this.$util.errorMsg(response.data.message);
                }
            })
        },

        // 给弹框绑定值
        bindclickout(row) {
            this.form.name = row.name;//姓名
            this.form.id = row.id;//用户id
            this.form.campus = row.university;//校区
            this.form.phone = row.phone;//电话号码
            this.form.stuId = row.stuId;//学号
            this.form.className = row.className;//院系名称
            this.form.caid = row.caid;//入学年份
            this.rowstate = row;
        },

        // 点击解冻
        clickUnfreeze(index, row) {
            const h = this.$createElement;
            this.$msgbox({
                title: '温馨提示',
                message: h('p', null, [
                    h('span', null, '该学生已被查出跑步违规。无法进行跑步，将在 '),
                    h('span', { style: 'color: red' }, this.handleDateTime(row.duration)),
                    h('span', null, ' 后解冻 '),
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then((action) => {
                this.sendUnfreeze(row);
            }).catch(() => { });
        },

        // 点击注销
        logout(index, row) {
            this.$alert("注销后将不可恢复，是否确认？", "", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                callback: action => {
                    if (action === "confirm") {
                        this.$http({
                            url: this.$util.domain + '/adminapi/v1/user/userLogout?uid=' + row.id,
                            method: 'GET'
                        }).then((response) => {
                            if (response.data.error == 10000) {
                                this.$util.successMsg('注销成功');
                                this.search()
                            } else {
                                this.$util.errorMsg(response.data.message);
                            }
                        })
                    }
                }
            });
        },

        // 点击赠送
        clickDonate(row) {
            this.donationDialog.visible = true;
            this.donationDialog.uid = row.id;
        },

        // 点击赠送弹框确认按钮
        clickDonationDone() {
            this.$refs.donationFormRef.validate((valid) => {
                if (valid) {
                    this.sendDonation();
                }
            });
        },

        // 切换分页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },

        // 点击「查看实名认证」
        clickViewCertify(row) {
            this.certifyDialog.uid = row.id;
            this.certifyDialog.certified = false;
            this.certifyDialog.records = [];
            this.certifyDialog.total = 0;
            this.certifyDialog.pageNumber = 1;
            this.certifyDialog.type = '1';
            this.certifyDialog.visible = true;
            this.fetchIdentityInfo();
        },

        // 查询实名状态与记录（type：1-认证记录，2-解绑记录）
        fetchIdentityInfo() {
            this.certifyDialog.loading = true;
            this.$http({
                url: this.$util.domain + '/adminapi/v70390/user/basicUser/identityInfo',
                method: 'POST',
                body: {
                    uid: this.certifyDialog.uid,
                    type: Number(this.certifyDialog.type),
                    pageNum: this.certifyDialog.pageNumber,
                    pageSize: this.certifyDialog.pageSize
                }
            }).then((res) => {
                const body = res.body || {};
                // 文档示例成功码为 0，项目惯例为 10000，两者都认
                if (body.error === 10000 || body.error === 0) {
                    const data = body.data || {};
                    this.certifyDialog.certified = !!data.certified;
                    // type=1 取认证记录，type=2 取解绑记录
                    this.certifyDialog.records =
                        Number(this.certifyDialog.type) === 2
                            ? (data.unbindRecords || [])
                            : (data.certifyRecords || []);
                    this.certifyDialog.total = data.totalCount || 0;
                } else {
                    this.$util.errorMsg(body.message || '查询实名信息失败');
                    this.certifyDialog.records = [];
                    this.certifyDialog.total = 0;
                }
            }).catch((err) => {
                console.error('[实名认证] 查询失败', err);
                this.$util.errorMsg('查询实名信息失败');
                this.certifyDialog.records = [];
                this.certifyDialog.total = 0;
            }).finally(() => {
                this.certifyDialog.loading = false;
            })
        },

        // 切换「认证记录 / 解绑记录」：回到第一页并重新拉取
        handleCertifyTabClick() {
            this.certifyDialog.pageNumber = 1;
            this.fetchIdentityInfo();
        },

        // 状态列：认证记录映射 certifyStatus（0-预认证，1-认证中，2-认证成功，3-认证失败）；
        // 解绑记录 DTO 没有状态字段，固定展示「已解绑」
        getCertifyStatusText(row) {
            if (Number(this.certifyDialog.type) === 2) {
                return '已解绑';
            }
            const map = { 0: '预认证', 1: '认证中', 2: '认证成功', 3: '认证失败' };
            return map[row.certifyStatus] !== undefined ? map[row.certifyStatus] : '-';
        },

        // 操作时间格式化为 yyyy-MM-dd HH:mm:ss
        formatCertType(type) {
            // 0-身份证 11-港澳居民来往内地通行证 12-台湾居民来往大陆通行证 13-台湾居民居住证 14-港澳居民居住证 16-外国人永久居住证
           return type !== null ? ["身份证", '', '', '', '', '', '', '', '', '', '', '港澳居民来往内地通行证', '台湾居民来往大陆通行证', '台湾居民居住证', '港澳居民居住证', '', '外国人永久居住证'][+type] || "" : ''
        },
        // 兼容 时间戳(秒/毫秒) / Date / 各类日期字符串，解析失败时原样返回
        formatCertifyTime(val) {
            if (!val) return '-';
            const pad = (n) => String(n).padStart(2, '0');
            let date = null;
            if (val instanceof Date) {
                date = val;
            } else if (typeof val === 'number') {
                // 秒级时间戳（< 1e12）转毫秒
                date = new Date(val < 1e12 ? val * 1000 : val);
            } else if (typeof val === 'string') {
                if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(val)) return val;
                date = new Date(val);
                // 解析失败（如 Safari 不支持 "yyyy-MM-dd HH:mm:ss"）时降级成 / 分隔再试
                if (isNaN(date.getTime())) {
                    date = new Date(val.replace(/-/g, '/'));
                }
            }
            if (!date || isNaN(date.getTime())) return val;
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
        },

        // 认证记录切换分页：分页由服务端完成，需重新请求
        handleCertifyPageChange(page) {
            this.certifyDialog.pageNumber = page;
            this.fetchIdentityInfo();
        },

        // 点击「解绑实名认证」：打开二次确认弹窗（后台接口跳过 180 天冷却，必须确认）
        clickUnbindCertify() {
            this.unbindConfirm.visible = true;
        },

        // 确认解绑
        confirmUnbindCertify() {
            this.unbindConfirm.loading = true;
            this.$http({
                url: this.$util.domain + '/adminapi/v70390/user/basicUser/unbindCertify',
                method: 'POST',
                params: { uid: this.certifyDialog.uid }
            }).then((res) => {
                const body = res.body || {};
                if (body.error === 10000 || body.error === 0) {
                    this.$util.successMsg('解绑成功');
                    this.unbindConfirm.visible = false;
                    // 解绑后重新拉取，刷新认证状态与记录
                    this.fetchIdentityInfo();
                } else {
                    this.$util.errorMsg(body.message || '解绑失败');
                }
            }).catch((err) => {
                console.error('[实名认证] 解绑失败', err);
                this.$util.errorMsg('解绑失败');
            }).finally(() => {
                this.unbindConfirm.loading = false;
            })
        },

        // 处理时间秒为天时分秒格式
        handleDateTime(second) {
            const days = Math.floor(second / 86400)
            const hours = Math.floor((second % 86400) / 3600)
            const minutes = Math.floor(((second % 86400) % 3600) / 60)
            const seconds = Math.floor(((second % 86400) % 3600) % 60)
            let duration = ''
            if (days) {
                duration += `${days}天`
            }
            if (hours) {
                duration += `${hours}小时`
            }
            if (minutes) {
                duration += `${minutes}分钟`
            }
            if (seconds) {
                duration += `${seconds}秒`
            }
            return duration
        },

    }
}
</script>

<style scoped>
.userManage .el-input {
    width: auto;
}

.userManage .el-button+.el-button {
    margin-left: 0;
}

.tips-content {
    margin-left: 20px;
    margin-bottom: 20px;
    color: red;
    font-size: 14px;
    line-height: 28px;
}

.search-bezel {
    margin: 0px 10px 20px 20px;
}

.el-dialog__body p {
    line-height: 38px;
}

.freeze-form .el-form-item {
    margin-bottom: 0px;
}

.freeze-form .el-form-item:nth-child(1) {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.freeze-form .el-radio-group {
    display: flex;
    flex-direction: row;
}

.freeze-form p {
    margin-bottom: 10px;
    font-size: 12px;
}

.freeze-form .select-bezel {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.freeze-form .el-select {
    flex: 1;
    margin-right: 8px;
}

.freeze-form .card-wrap {
    box-sizing: border-box;
    width: 100%;
    height: 200px;
    overflow: auto;
    padding: 10px;
    margin: 8px 0 4px;
    border: 1px solid #c0ccda;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.5;
}

.freeze-form .card-wrap .card-item {
    display: inline-block;
    margin: 0 4px 4px;
    padding: 0px 4px;
    border: 1px solid #c0ccda;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.5;
}

.freeze-form .card-footer {
    text-align: right;
    font-size: 14px;
    line-height: 1.5;
}

/* 查看支付宝实名认证弹窗 */
.certify-status-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}

.certify-status-bar__text {
    font-size: 14px;
    color: #303133;
}

/* 认证记录 / 解绑记录 切换：tab 仅作切换器，内容区在 tabs 外面，隐藏空面板 */
.certify-tabs {
    margin-bottom: 10px;
}

.certify-tabs .el-tabs__content {
    display: none;
}

.certify-pagination {
    margin-top: 15px;
    text-align: right;
}

/* 解绑二次确认弹窗 */
.unbind-confirm-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    line-height: 1.6;
}

.unbind-confirm-body__icon {
    margin-right: 8px;
    color: #f56c6c;
    font-size: 20px;
}


</style>


// WEBPACK FOOTER //
// AllUsers.vue?456be8a5